import { mediaModuleClient } from 'common/services';
import { type MediaDataObject } from 'models/service';

// TODO: change to new routes, figure out how to handle node and media routes
export const getVideoMedia = async ({ mediaId }: { mediaId?: string }) =>
  mediaModuleClient.get<MediaDataObject>(`media/${mediaId}`);
